import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsParseDotLyComponent } from './simple-icons-parse-dot-ly.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsParseDotLyComponent ],
    exports:      [ SimpleIconsParseDotLyComponent ],
    bootstrap:    []
})
export class SimpleIconsParseDotLyModule {}
